export const UrlParameterNames = {
  language: "language",
  onlySearchNormalSpeed: "only-normal-speed",
  text: "text",
  ttsHash: "tts-hash",
  voice: "voice",
};
